module.exports = __webpack_public_path__ + "img/about_history_imaging.caccf127.jpg";